import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_54604f30 from 'nuxt_plugin_plugin_54604f30' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_55867a84 from 'nuxt_plugin_plugin_55867a84' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_toast_e867e216 from 'nuxt_plugin_toast_e867e216' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_vuesweetalert2_612b7746 from 'nuxt_plugin_vuesweetalert2_612b7746' // Source: ./vue-sweetalert2.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_674415ee from 'nuxt_plugin_cookieuniversalnuxt_674415ee' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_nuxtsvgsprite_70cffde4 from 'nuxt_plugin_nuxtsvgsprite_70cffde4' // Source: ./nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_client_71edc27e from 'nuxt_plugin_client_71edc27e' // Source: ../plugins/client (mode: 'client')
import nuxt_plugin_ssr_5e4666dc from 'nuxt_plugin_ssr_5e4666dc' // Source: ../plugins/ssr (mode: 'all')
import nuxt_plugin_basecomponents_fb241548 from 'nuxt_plugin_basecomponents_fb241548' // Source: ../plugins/base-components (mode: 'all')
import nuxt_plugin_basefeatures_65ea3003 from 'nuxt_plugin_basefeatures_65ea3003' // Source: ../plugins/base-features (mode: 'all')
import nuxt_plugin_nuxtquillplugin_36d64ccf from 'nuxt_plugin_nuxtquillplugin_36d64ccf' // Source: ../plugins/nuxt-quill-plugin (mode: 'client')
import nuxt_plugin_apexcharts_6eb9cbed from 'nuxt_plugin_apexcharts_6eb9cbed' // Source: ../plugins/apexcharts (mode: 'client')
import nuxt_plugin_filesize_7164061a from 'nuxt_plugin_filesize_7164061a' // Source: ../plugins/filesize (mode: 'all')
import nuxt_plugin_msal_6a83b8c7 from 'nuxt_plugin_msal_6a83b8c7' // Source: ../plugins/msal (mode: 'all')
import nuxt_plugin_barcode_5a25c76c from 'nuxt_plugin_barcode_5a25c76c' // Source: ../plugins/barcode (mode: 'client')
import nuxt_plugin_JsonEditorVue_70793fc4 from 'nuxt_plugin_JsonEditorVue_70793fc4' // Source: ../plugins/JsonEditorVue.client (mode: 'client')
import nuxt_plugin_monaco_4f73de12 from 'nuxt_plugin_monaco_4f73de12' // Source: ../plugins/monaco (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"PAM Management System","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Lexend:wght@100;300;400;500;600;700;800&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Fira%20Code:wght@100;300;400;500;600;700;800&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Ficon?family=Material+Icons"},{"rel":"stylesheet","href":"\u002Fcss\u002Fmaterialdesignicons.min.css"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_54604f30 === 'function') {
    await nuxt_plugin_plugin_54604f30(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_55867a84 === 'function') {
    await nuxt_plugin_plugin_55867a84(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_e867e216 === 'function') {
    await nuxt_plugin_toast_e867e216(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuesweetalert2_612b7746 === 'function') {
    await nuxt_plugin_vuesweetalert2_612b7746(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_674415ee === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_674415ee(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_70cffde4 === 'function') {
    await nuxt_plugin_nuxtsvgsprite_70cffde4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_client_71edc27e === 'function') {
    await nuxt_plugin_client_71edc27e(app.context, inject)
  }

  if (typeof nuxt_plugin_ssr_5e4666dc === 'function') {
    await nuxt_plugin_ssr_5e4666dc(app.context, inject)
  }

  if (typeof nuxt_plugin_basecomponents_fb241548 === 'function') {
    await nuxt_plugin_basecomponents_fb241548(app.context, inject)
  }

  if (typeof nuxt_plugin_basefeatures_65ea3003 === 'function') {
    await nuxt_plugin_basefeatures_65ea3003(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtquillplugin_36d64ccf === 'function') {
    await nuxt_plugin_nuxtquillplugin_36d64ccf(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_apexcharts_6eb9cbed === 'function') {
    await nuxt_plugin_apexcharts_6eb9cbed(app.context, inject)
  }

  if (typeof nuxt_plugin_filesize_7164061a === 'function') {
    await nuxt_plugin_filesize_7164061a(app.context, inject)
  }

  if (typeof nuxt_plugin_msal_6a83b8c7 === 'function') {
    await nuxt_plugin_msal_6a83b8c7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_barcode_5a25c76c === 'function') {
    await nuxt_plugin_barcode_5a25c76c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_JsonEditorVue_70793fc4 === 'function') {
    await nuxt_plugin_JsonEditorVue_70793fc4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_monaco_4f73de12 === 'function') {
    await nuxt_plugin_monaco_4f73de12(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
